import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormPanesSettingsUtil } from '@form/cer-form-panes/cer-form-panes.service';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

import { UiCommand, UiCommandEvent } from '@cer/cer-ui/cer-ui-types';

import { DocumentLibUserForm } from './document-lib-user.form';
import { CerUiIcons } from '@cer/cer-ui/cer-ui-icons';
import { DataLinkAttachmentClient, DocumentLibDto } from '@app/api';

const uiCmdSyncFolders: UiCommand = { id: 'syncFoldes', text: 'Synkroniser', tooltipText: 'Synkroniser alle filer i folder', iconCss: CerUiIcons.research, target: '.e-header-content' };
export const documentLibEntityName = 'DocumentLib';

export class DocumentLibForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {

    viewSet.panes = CerFormPanesSettingsUtil.masterDetail('horizontal', true, 30);

    const libView = this.viewDocGet()
    viewSet.viewAdd(libView);

    const userView = DocumentLibUserForm.viewUserGet()
    userView.title = 'Adgang';
    userView.paneTarget = 'right';
    viewSet.viewAdd(userView, libView, { parent: 'id', child: 'documentLib' });
  }

  private viewDocGet(): CerFormView {
    return new CerFormView({
      paneTarget: 'main',
      viewMetadata: {
        dataApiName: documentLibEntityName, text: 'Dokumentarkiver', textSingular: 'Dokumentarkiv',
        primaryKey: 'id', titleFields: ['name'], baseFields: ['id', 'name', 'history']
      },
      fieldMetadata: [
        { fieldType: 'blobStorage', required: true },
        { name: 'path', text: 'Sti', tooltipText: 'Relativ sti', required: true }
      ],
      toolbarCommands: [uiCmdSyncFolders],
      onCommandEvent: (e) => { this.onCommand(e) }
    });
  }

  private onCommand(e: UiCommandEvent) {
    if (e.commandId == uiCmdSyncFolders.id) {
      this.syncFolder(e.rowData as DocumentLibDto);
    }
  }

  private syncFolder(dto: DocumentLibDto) {
    const docLibs = this.context.session.user.documentLibs$.getValue();
    const docLib = docLibs?.find(l => l.id == dto.id);
    if (docLib?.token == null) {
      this.context.ui.error("Dokument bibliotek er p.t. ikke tilængeligt");
      return;
    }
    this.doSyncFolder(`${uiCmdSyncFolders.text}: ${dto.name}`, dto.id, '/', docLib.token, true);
  }

  private doSyncFolder(title: string, rowId: number, folderName: string, token: string, includeSubFolders: boolean) {
    const client = this.context.injector.get(DataLinkAttachmentClient);
    const ui = this.context.ui;
    ui.operationBegin("Afvikler", title);
    try {

      client.syncList(documentLibEntityName, rowId, folderName, null, token, includeSubFolders, false).subscribe({
        next: (count) => {
          ui.operationEnd(`Fuldført (${count} filer)`);
        },
        error: (error) => {
          ui.operationEndError(error);
        }
      });
    }
    catch (error) {
      ui.operationEndError(error);
    }
  }
}
